import {
  Membership as SharedMembership,
  MembershipStatus as SharedMembershipStatus,
  MEMBERSHIP_STATUSES as SharedMembershipStatuses,
} from "shared/dist/types/Membership";

export type MembershipStatus = SharedMembershipStatus;
export const MEMBERSHIP_STATUSES = SharedMembershipStatuses;

export default interface Membership extends SharedMembership {}